import {
  ChangePasswordDto,
  CreateUserDto,
  DeleteUserDto,
  IRole,
  IUser,
  SendPasswordResetDto,
  UpdateAccountSettingsDto,
  UpdateAchievementDto,
  UpdateUserDto,
  UserFilterDto,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class UserApi {
  static getUsers(filter?: UserFilterDto): Promise<AxiosResponse<IUser[]>> {
    return AdmiralApi.apiCall<IUser[]>({
      method: 'POST',
      url: `${BASE_URL}/user`,
      data: filter,
    });
  }

  static getUserRoles(): Promise<AxiosResponse<IRole[]>> {
    return AdmiralApi.apiCall<IRole[]>({
      method: 'POST',
      url: `${BASE_URL}/user/roles`,
    });
  }
  static create(createUserDto: CreateUserDto): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall<IUser>({
      method: 'POST',
      url: `${BASE_URL}/user/create`,
      data: createUserDto,
    });
  }

  static update(id: string, updateUserDto: UpdateUserDto): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall<IUser>({
      method: 'PATCH',
      url: `${BASE_URL}/user/${id}`,
      data: updateUserDto,
    });
  }

  static updateAchievement(id: string, dto: UpdateAchievementDto): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall<IUser>({
      method: 'PATCH',
      url: `${BASE_URL}/user/${id}/update-achievement`,
      data: dto,
    });
  }

  static updateAccountSettings(
    id: string,
    updateAccountSettingsDto: UpdateAccountSettingsDto,
  ): Promise<AxiosResponse<IUser>> {
    return AdmiralApi.apiCall<IUser>({
      method: 'PATCH',
      url: `${BASE_URL}/user/${id}/settings`,
      data: updateAccountSettingsDto,
    });
  }

  static delete(id: string, deleteUserDto: DeleteUserDto): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/user/${id}`,
      data: deleteUserDto,
    });
  }

  static validateDelete(deleteUserDto: DeleteUserDto): Promise<
    AxiosResponse<
      IUser & {
        tasksCount: number;
        policiesCountCanceled: number;
        policiesCountDeclined: number;
        policiesCountPoliced: number;
        policiesCountSubmitted: number;
        policiesCountOpen: number;
        policiesCountPlanned: number;
      }
    >
  > {
    return AdmiralApi.apiCall<
      IUser & {
        tasksCount: number;
        policiesCountCanceled: number;
        policiesCountDeclined: number;
        policiesCountPoliced: number;
        policiesCountSubmitted: number;
        policiesCountOpen: number;
        policiesCountPlanned: number;
      }
    >({
      method: 'POST',
      url: `${BASE_URL}/user/delete/validate`,
      data: deleteUserDto,
    }) as Promise<
      AxiosResponse<
        IUser & {
          tasksCount: number;
          policiesCountCanceled: number;
          policiesCountDeclined: number;
          policiesCountPoliced: number;
          policiesCountSubmitted: number;
          policiesCountOpen: number;
          policiesCountPlanned: number;
        }
      >
    >;
  }

  static removeProfilePicture(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'PUT',
      url: `${BASE_URL}/user/${id}/remove-profile-picture`,
    });
  }
  static setProfilePicture(id: string, formData: FormData): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<void>({
      method: 'POST',
      url: `${BASE_URL}/user/${id}/set-profile-picture`,
      data: formData,
    });
  }

  static sendResetEmail(data: SendPasswordResetDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<void>({
      method: 'POST',
      url: `${BASE_URL}/user/send-reset-email`,
      data,
    });
  }

  static changePassword(changePasswordDto: ChangePasswordDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall<void>({
      method: 'POST',
      url: `${BASE_URL}/user/change-password`,
      data: changePasswordDto,
    });
  }
}
